<template>
   <div class="info-card-header">
      {{ title }}
   </div>
</template>

<script>
export default {
   name: 'infographics-card-header',
   props: {
      title: {
         type: String,
         required: true,
      }
   }
}
</script>

<style lang="scss" scoped>
$border-color: lighten($secondary-color, 40%);

.info-card-header {
   border-bottom: 1px solid $border-color;
   padding: 10px 15px;
   color: $dark-color;
   font-weight: 500;
   font-family: $secondary-font;
   text-align: left;
}
</style>